import { DataBean } from "../DataBean";

export class AdjustmentConstant extends DataBean {



    public async getIncomeStateAdjustmentConstant(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getIncomeStateAdjustmentConstant_Number", [id]);
    }
    
}